// 新客优惠专区路由
export default {
  routes: [
    // 新客专享红包列表
    {
      path: '/exclusiveRedEnvelope',
      name: 'exclusiveRedEnvelope',
      meta: {
        desc: '新客专享红包',
        pageId: 'A6068',
        level: 2
      },
      component: () =>
        import(
          /* webpackChunkName: "exclusiveRedEnvelope" */ '../views/newUserTab/exclusiveRedEnvelope.vue'
        )
    },
    // 新客专享规则
    {
      path: '/newUserActivityRule',
      name: 'newUserActivityRule',
      meta: {
        desc: '新客专享规则'
      },
      component: () =>
        import(/* webpackChunkName: "newUserActivityRule" */ '../views/newUserTab/Rule.vue')
    }
  ]
}
